export const APPLICATION_FORM_URL_ENCODED = "application/x-www-form-urlencoded";
export const APPLICATION_JSON = "application/json";

export default {
    APPLICATION_FORM_URL_ENCODED,
    APPLICATION_JSON
};
